import { useHistory, useLocation } from 'react-router-dom';
import {
  ListItemButton, ListItemIcon, Typography,
} from '@mui/material';

type Props = {
  text: string,
  icon: React.ReactNode,
  link?: string,
  onClick?: () => void,
};

const Item = ({
  icon, text, onClick, link,
}:Props):JSX.Element => {
  const history = useHistory();
  const location = useLocation();

  const active = location.pathname === link;

  const action = () => {
    if (onClick) {
      onClick();
    } else if (link) {
      history.push(link);
    }
  };

  return (
    <ListItemButton onClick={action}>
      <ListItemIcon
        sx={{
          paddingLeft: 2,
          color: active ? 'primary.main' : 'neutral.400',
          marginY: 0.8,
        }}
      >
        {icon}
      </ListItemIcon>
      <Typography fontWeight={active ? 600 : 'normal'} color={active ? 'initial' : 'neutral.500'}>
        {text}
      </Typography>
    </ListItemButton>
  );
};
export default Item;
